/*!
 * KoliBri - The accessible HTML-Standard
 */
import { e as watchBoolean } from './common-D-vggmh2.js';

const validateHideLabel = (component, value, options = {}) => {
    watchBoolean(component, '_hideLabel', value, options);
};

export { validateHideLabel as v };
//# sourceMappingURL=hide-label-CRGm6KGP.js.map

//# sourceMappingURL=hide-label-CRGm6KGP.js.map